import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { Carnet, CarnetInfo } from '../../../shared/interface';
import { Table } from 'primeng/table';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-carnet-backoffice',
  templateUrl: './carnet-backoffice.component.html',
  styleUrl: './carnet-backoffice.component.css'
})
export class CarnetBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) { }

  @ViewChild("deleteCarnet") deleteCarnet!: ConfirmPopup;

  carnets: Carnet[] = [];
  carnet_info?: CarnetInfo;

  loading: boolean = false;
  add_info: boolean = false;

  formInfo!: FormGroup;

  ngOnInit(): void {

    this.formInfo = new FormGroup({
      titolo: new FormControl(null, Validators.required),
      descrizione: new FormControl(null),
      link: new FormControl(null),
      attivo: new FormControl(['attivo'])
    })

    this.loading = true;

    this.apiService.setCarnets();
    this.apiService.carnetsChanged.subscribe({
      next: (data) => {
        this.carnets = [...data];
        this.loading = false;

        this.apiService.getCarnetInfo().subscribe({
          next: (data) => this.carnet_info = data,
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message)
        })
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    })
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteCarnet(event: Event, carnet: Carnet) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare il carnet?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteCarnet(carnet.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.apiService.setCarnets()
            this.apiService.message("success", "Eliminazione", "Il carnet è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeleteCarnet() {
    this.deleteCarnet.accept();
  }

  onAnnullaDeleteCarnet() {
    this.deleteCarnet.reject();
  }

  onReorder(e: any) {

    this.carnets.map((carnet, index) => carnet.posizione = index)

    this.apiService.updateCarnets({ carnets: this.carnets }).subscribe({
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.apiService.setCarnets()
        this.apiService.message("success", "Aggiornamento", "La posizione dei carnet è stata modificata con successo")
      }
    })


  }

  onOpenInfo() {

    this.add_info = true;

    this.formInfo.patchValue({
      titolo: this.carnet_info?.titolo,
      descrizione: this.carnet_info?.descrizione,
      link: this.carnet_info?.link,
      attivo: this.carnet_info?.attivo !== false ? ['attivo'] : [],
    })
  }

  private getInfoPayload() {
    return {
      titolo: this.formInfo.get('titolo')?.value,
      descrizione: this.formInfo.get('descrizione')?.value,
      link: this.formInfo.get('link')?.value,
      attivo: this.formInfo.get('attivo')?.value?.length > 0,
    }
  }

  onAddInfo() {
    this.apiService.addCarnetInfo(this.getInfoPayload()).subscribe({
      next: (data) => this.apiService.setCarnets(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.add_info = false;
        this.apiService.message('success', 'Successo', "Info caricate con successo!")
      }
    })
  }

  onUpdateInfo() {
    this.apiService.updateCarnetInfo(this.getInfoPayload()).subscribe({
      next: (data) => this.apiService.setCarnets(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.add_info = false;
        this.apiService.message('success', 'Successo', "Info aggiornate con successo!")
      }
    })
  }

}
